export var GameStatuses;
(function (GameStatuses) {
    GameStatuses[GameStatuses["Waiting"] = 0] = "Waiting";
    GameStatuses[GameStatuses["FirstHalf"] = 1] = "FirstHalf";
    GameStatuses[GameStatuses["SecondHalf"] = 2] = "SecondHalf";
    GameStatuses[GameStatuses["EndOfFirstHalf"] = 3] = "EndOfFirstHalf";
    GameStatuses[GameStatuses["PausedFirstHalf"] = -1] = "PausedFirstHalf";
    GameStatuses[GameStatuses["PausedSecondHalf"] = -2] = "PausedSecondHalf";
    GameStatuses[GameStatuses["PauseBetweenHalves"] = -3] = "PauseBetweenHalves";
    GameStatuses[GameStatuses["EndOfGame"] = 6] = "EndOfGame";
})(GameStatuses || (GameStatuses = {}));
//# sourceMappingURL=GameStatuses.js.map